import { isGokollab, isPwa } from '@ghl/clientportal-core/init'
import {
  AnnotationInfoIcon,
  BookClosedIcon,
  Home05Icon,
  MessageChatCircleIcon,
  User02Icon,
} from '@gohighlevel/ghl-icons/24/outline'
import { h, reactive } from 'vue'

import AvatarIcon from '@/components/common/avatar/AvatarIcon.vue'
import FillBookCloseIcon from '@/components/common/icons/FillBookCloseIcon.vue'
// import FillCompass03Icon from '@/components/common/icons/FillCompass03Icon.vue'
import FillHomeSmileIcon from '@/components/common/icons/FillHomeSmileIcon.vue'
import FillLeaderBoardIcon from '@/components/common/icons/FillLeaderBoardIcon.vue'
import FillMessageChatCircleIcon from '@/components/common/icons/FillMessageChatCircleIcon.vue'
import FillUsers02Icon from '@/components/common/icons/FillUsers02Icon.vue'
import LeaderBoardIcon from '@/components/common/icons/LeaderBoardIcon.vue'
import { app } from '@/composition/app'
import { NavigationItemType } from '@ghl/clientportal-core'

class Navigation {
  state = reactive({
    navigationItems: [
      {
        name: 'tabSwitcher.home',
        label: 'tabSwitcher.home',
        routeName: app.state.isMobile ? [`clientportal-home`] : [],
        type: app.state.isMobile
          ? NavigationItemType.APP_ROUTE
          : NavigationItemType.REDIRECTION,
        redirectionUrl: `${window.location.origin}/home`,
        showOnMobile: !isGokollab(),
        showOnWeb: false,
        icon: () => h(Home05Icon),
        selectedIcon: () => h(FillHomeSmileIcon),
      },
      {
        name: 'tabSwitcher.discussion',
        label: 'tabSwitcher.discussion',
        routeName: [
          'home',
          'channel-overview',
          'channel-post-view',
          'group-post-view',
          'content-unavailable',
          /** search router */
          'group-home-search',
          'group-search-post-view',
          'channel-search',
          'channel-search-post-view',
        ],
        current: true,
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: true,
        icon: () => h(MessageChatCircleIcon),
        selectedIcon: () => h(FillMessageChatCircleIcon),
        isSearchAvailable: true,
      },
      {
        name: 'tabSwitcher.communities',
        label: 'tabSwitcher.communities',
        routeName: [
          'home',
          'channel-overview',
          'channel-post-view',
          'group-post-view',
          'content-unavailable',
          /** search router */
          'group-home-search',
          'group-search-post-view',
          'channel-search',
          'channel-search-post-view',
          'learning-home',
          'group-member-list',
          `events`,
          `leaderboard`,
          `about`,
        ],
        current: true,
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: true,
        showOnWeb: false,
        icon: () => h(MessageChatCircleIcon),
        selectedIcon: () => h(FillMessageChatCircleIcon),
        isSearchAvailable: true,
      },
      {
        name: 'tabSwitcher.learning',
        label: 'tabSwitcher.learning',
        routeName: [`learning-home`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: true,
        icon: () => h(BookClosedIcon),
        selectedIcon: () => h(FillBookCloseIcon),
      },
      {
        name: 'tabSwitcher.courses',
        label: 'tabSwitcher.courses',
        routeName: [`learning-home-dummy`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: true,
        showOnWeb: false,
        icon: () => h(BookClosedIcon),
        selectedIcon: () => h(FillBookCloseIcon),
      },

      {
        name: 'common.manage',
        label: 'common.manage',
        routeName: [`to-review`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: false,
        icon: () => h(User02Icon),
        selectedIcon: () => h(FillUsers02Icon),
      },
      {
        name: 'common.events',
        label: 'common.events',
        routeName: [`events`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: true,
      },
      {
        name: 'tabSwitcher.leaderboard',
        label: 'tabSwitcher.leaderboard',
        routeName: [`leaderboard`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: true,
        icon: () => h(LeaderBoardIcon),
        selectedIcon: () => h(FillLeaderBoardIcon),
      },
      {
        name: 'tabSwitcher.members',
        label: 'tabSwitcher.members',
        routeName: [`group-member-list`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: true,
        icon: () => h(User02Icon),
        selectedIcon: () => h(FillUsers02Icon),
      },
      {
        name: 'common.about',
        label: 'common.about',
        routeName: [`about`, `private-group`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: false,
        showOnWeb: true,
        icon: () => h(AnnotationInfoIcon),
        selectedIcon: () => h(AnnotationInfoIcon),
      },
      // {
      //   name: 'Notifications',
      //   routeName: [`NotificationMobileView`],
      //   type: NavigationItemType.APP_ROUTE,
      //   showOnMobile: true,
      //   showOnWeb: false,
      //   icon: () => h(Bell02Icon),
      //   selectedIcon: () => h(FillBellVue),
      // },
      // {
      //   name: 'Profile',
      //   routeName: [`profile-container`],
      //   type: NavigationItemType.APP_ROUTE,
      //   showOnMobile: true,
      //   showOnWeb: false,
      //   icon: () => h(User02Icon),
      //   selectedIcon: () => h(FillUsers02Icon),
      // },
      {
        name: 'userProfilePopover.profile',
        label: 'userProfilePopover.profile',
        routeName: isPwa() ? [`profile-container`] : [],
        type: isPwa()
          ? NavigationItemType.APP_ROUTE
          : NavigationItemType.REDIRECTION,
        redirectionUrl: `${window.location.origin}/account?activeTab=Profile`,
        showOnMobile: false,
        showOnWeb: false,
        icon: () => h(User02Icon),
        selectedIcon: () => h(FillUsers02Icon),
      },
      {
        name: 'tabSwitcher.more',
        label: 'tabSwitcher.more',
        routeName: [`communities-more`, `profile-container`],
        type: NavigationItemType.APP_ROUTE,
        showOnMobile: true,
        showOnWeb: false,
        icon: () => h(AvatarIcon as any, { active: false, size: 'small' }),
        selectedIcon: () =>
          h(AvatarIcon as any, { active: true, size: 'small' }),
      },
    ],
  })
}

export const navigation = new Navigation()
